<template>
  <div class="download">
    <img :src="require(is1920 ? '../assets/chongdianapp.png' : '../assets/chongdianapp2880.png')"/>
    <div class="desc">
      <div class="title">国恒充电APP</div>
      <div class="prompt">下载国恒充电APP，随时随地为爱车充电</div>
      <div class="imgs">
        <img class="qrcode" :src="require('../assets/qrcode.png')"/>
        <!-- <img class="platform" :src="require('../assets/platform.png')"/> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'download',
  inject: ['is1920']
}
</script>
<style lang="less">
.download{
  position: relative;
  width: 100%;
  height: 9rem;
  img{
    width: 100%;
    height: 9rem;
  }
  .desc{
    position: absolute;
    top: 1.9rem;
    left: 2.27rem;
    width: 365px;
    text-align: center;
    .title{
      font-size: .45rem;
      line-height: .63rem;
      color: #292929;
    }
    .prompt{
      font-size: .2rem;
      line-height: .28rem;
      color: #292929;
      margin: .2rem 0 .33rem;
    }
    .imgs{
      text-align: center;
      .qrcode{
        width: 1.8rem;
        height: 1.73rem;
        margin-right: .31rem;
      }
      .platform{
        width: 1.8rem;
        height: 1.08rem;
      }
    }
  }
}
</style>
